/* Read-only locale-aware product data for browser-saved wishlist and history. */
(function () {
  'use strict';
  if (window.CarlaLocalizedProducts) return;
  let config = {};
  try { config = JSON.parse(document.getElementById('CarlaLocaleConfig')?.textContent || '{}'); } catch (e) { /* use storefront defaults */ }
  const locale = config.locale || document.documentElement.lang || 'pl';
  let root = config.root_url || window.Shopify?.routes?.root || '/';
  root = '/' + String(root).replace(/^\/+|\/+$/g, '');
  if (!root.endsWith('/')) root += '/';
  const currency = config.currency || window.Shopify?.currency?.active || '';
  const cache = new Map();
  const queue = [];
  let active = 0;

  function pump() {
    while (active < 4 && queue.length) {
      const task = queue.shift();
      active += 1;
      Promise.resolve().then(task.work).then(task.resolve, task.reject).finally(() => { active -= 1; pump(); });
    }
  }
  function schedule(work) {
    return new Promise((resolve, reject) => { queue.push({ work, resolve, reject }); pump(); });
  }
  function handleFor(item) {
    if (item.handle) return String(item.handle);
    try {
      const path = new URL(item.url, window.location.origin).pathname;
      const part = path.split('/products/')[1];
      return part ? decodeURIComponent(part.split('/')[0]) : '';
    } catch (e) { return ''; }
  }
  function localUrl(item, handle) {
    if (!handle) return item.url || root;
    let suffix = '';
    try {
      const variant = new URL(item.url, window.location.origin).searchParams.get('variant');
      if (variant && /^\d+$/.test(variant)) suffix = '?variant=' + variant;
    } catch (e) { /* product-level link */ }
    return root + 'products/' + encodeURIComponent(handle) + suffix;
  }
  function money(cents, fallback) {
    if (!Number.isFinite(Number(cents)) || !currency) return fallback || '';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents) / 100); }
    catch (e) { return fallback || ''; }
  }
  function request(handle) {
    const key = [root, config.country || '', currency, handle].join('|');
    const cached = cache.get(key);
    if (cached && cached.expires > Date.now()) return cached.promise;
    const promise = schedule(async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        const data = await response.json();
        if (!data || !data.id || typeof data.title !== 'string') throw new Error('Invalid product response');
        return data;
      } finally { clearTimeout(timer); }
    });
    cache.set(key, { promise, expires: Date.now() + 300000 });
    promise.catch(() => cache.delete(key));
    return promise;
  }
  async function get(item) {
    const handle = handleFor(item);
    const fallback = { ...item, url: localUrl(item, handle) };
    if (!handle) return fallback;
    try {
      const product = await request(handle);
      if (item.id && String(product.id) !== String(item.id)) return fallback;
      return {
        ...item,
        handle: product.handle || handle,
        title: product.title,
        type: product.type || '',
        url: localUrl(item, product.handle || handle),
        image: product.featured_image || item.image || '',
        price: money(product.price, item.price)
      };
    } catch (e) { return fallback; }
  }
  window.CarlaLocalizedProducts = { get, url: (item) => localUrl(item, handleFor(item)) };
})();
